import type { Form } from 'factorial-form'
import sortBy from 'lodash/sortBy'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import { createForm } from 'modules/custom_resources/components/CustomFields/CustomFieldsForm/createForm'
import { isEditable } from 'modules/custom_resources/lib/utils'
import type CustomFieldsCollection from 'modules/custom_resources/store/collections/customFields/fields'
import type CustomValue from 'modules/custom_resources/store/models/customFields/Value'
import type Employee from 'modules/employees/store/models/Employee'

export const createFieldsForms = (
  fieldsCollection: CustomFieldsCollection,
  employee: Employee,
  contractVersions: ContractVersions,
  values: CustomValue[] = []
): Form[] => {
  const visibleCustomFields = fieldsCollection.models.filter((field) =>
    isEditable(field.get('editable'), contractVersions, employee)
  )

  return sortBy(visibleCustomFields, (field) => field.get('position')).map((field) =>
    createForm(field, values, contractVersions, employee)
  )
}
